import { render, staticRenderFns } from "./StepA.vue?vue&type=template&id=1c9ff500&scoped=true&"
import script from "./StepA.vue?vue&type=script&lang=js&"
export * from "./StepA.vue?vue&type=script&lang=js&"
import style0 from "./StepA.vue?vue&type=style&index=0&id=1c9ff500&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9ff500",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
